



















import { Component, Vue,Inject, Prop,Watch } from 'vue-property-decorator';
import Util from '../../../lib/util'
import AbpBase from '../../../lib/abpbase'
import myTable from '../../../components/table/my-table.vue'
import {GetQueryStockActionDetailList} from '../../../api/storehouse'
import util from '../../../lib/util'
@Component({
    components:{myTable}
})
export default class extends AbpBase{
    @Prop({type:Boolean,default:false}) value:boolean;
    @Prop({type:Object,default:{}}) data:any;   
    @Prop({type:Number,default:1}) actionType:number;
    list:any = []
    //操作类型
    actionTypeOptions:any = [
        {value:1,text:'入库'},
        {value:2,text:'出库'},
        {value:3,text:'报损'},
        {value:4,text:'盘点'},
    ]
    getactionName(){
        return this.actionTypeOptions.find((item:any)=>{return item.value == this.actionType}).text
    }

    created(){
        this.getData()
    }
    //
    async getData(){
        let res = await GetQueryStockActionDetailList({ActionId:this.data.actionId})
        this.list = res.data
    }
    columns:Array<object> = [
        {title:'物资类型',key:'itemTypeName'},
        {title:'物资编号',key:'materialCode'},
        {title:'物资名称',key:'materialName'},
        {title:'单位',key:'unitName'},
        {title:'数量',key:'quantity'},
        {title:'原数量',key:'quantity',isHidden:this.actionType!=4?true:false},
        {title:'现数量',key:'batchNo',isHidden:this.actionType!=4?true:false},
        {title:'价格',key:'expireDate'},
        {title:'批号',key:'batchNo'},
        {
            title:'有效期',
            key:'validityPeriod',
            render:(h:any,p:any)=>{
                return h('span',util.formatTime(p.row.validityPeriod))
            }
        },
        {title:'报损原因',key:'breakageReason',isHidden:this.actionType!=3?true:false},
    ]
    cancel(){
        this.$emit('input',false);
    }
    visibleChange(value:boolean){
        if(!value){
            this.$emit('input',value);
        }
    }
}
